// extracted by mini-css-extract-plugin
module.exports = {"container":"PleaseSupportUs_container__NF4TW","insetBorder":"PleaseSupportUs_insetBorder__9eki8"};